/**
 * Label stock (Rhys 2026-10-09): every browser label print (product / PO / shelf / price /
 * text / package / tray labels) sends a fresh `printRequestId` to the generate route, so the
 * 40x28 roll is counted once per print, even if the request is retried.
 */
export function newLabelPrintRequestId() {
  return `lbl_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}
